module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAKCAYAAACJxx+AAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAABmJLR0QAAAAAAAD5Q7t/AAAACXBIWXMAAAsSAAALEgHS3X78AAAAd0lEQVQY03XOwQ0BARhE4W/ZIx2owHX/gzKU4SKUsipBFyTjqgEtuAonicjuu76XzEhyTLIwwgRr3JPskkyHApijxzVJNxR86XBJ0ieZQZPkPTL/wHZinAbNUPDCAcuqOrV/8oZNVeX/5BN7rH4ltDhjW1WPoSMfqDwmXORXQDMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/images/personal_center/collection-right.png
// module id = SLie
// module chunks = 15